import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PROMO_CODE_FEATURE_KEY, State } from './promo-code.reducer';

// Lookup the 'PromoCode' feature state managed by NgRx
export const getApplyPromoCodeState = createFeatureSelector<State>(
  PROMO_CODE_FEATURE_KEY,
);

export const getPromoCode = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.promoCode,
);

export const getPromoCodeLoaded = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.loaded,
);

export const isShowPromoCodeDialog = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.isShowPromoCodeDialog,
);

export const isApplying = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.applying === 'LOADING',
);

export const isApplyingSuccess = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.applying === 'SUCCESS',
);

export const getPromoCodeError = createSelector(
  getApplyPromoCodeState,
  (state: State) => state.error,
);
